import { Component, HostBinding, Input } from '@angular/core';
import { LANGUAGE_CONSTANTS } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-resend-success',
  templateUrl: './resend-success.component.html',
  styleUrls: ['./resend-success.component.scss'],
})
export class ResendSuccessComponent {
  @Input() SuccessMessage!: string;
  @Input() headerTitle?: string;
  @Input() layoutType: 'default' | 'invitation' = 'default';
  @Input() dialogRef?: any;

  @HostBinding('class.invitation-layout')
  get isInvitationLayout(): boolean {
    return this.layoutType === 'invitation';
  }

  readonly LANG_CONST = LANGUAGE_CONSTANTS;
  CONSTANTS = CONSTANTS;

  constructor(
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }
}
